import Profile from '../../views/profile';
import TwoFA from '../../views/2fa';
import Kyc from '../../views/kyc';
import PasswordChangeView from '../../views/password-change';

/**
 * Router config based on RouteProps + module based on settings
 * https://reactrouter.com/web/example/route-config
 */
const routerConfig = [
  {
    name: 'profile',
    path: '/profile',
    module: 'profile',
    component: Profile
  },
  {
    name: 'password',
    path: '/password',
    module: 'password',
    component: PasswordChangeView
  },
  {
    name: '2fa',
    path: '/2fa',
    module: '2fa',
    component: TwoFA
  },
  {
    name: 'kyc',
    path: '/kyc',
    module: 'kyc',
    component: Kyc
  }
];

export default routerConfig;
